export const dollarString = (withPrefix: boolean) => withPrefix ? "US$" : "$";
